const ru_in_risks_page = {
  address: 'Адрес',
  type: 'Тип',
};
const ru = {
  deposit: 'Депозит',
  Deposit: 'Депозит',
  withdraw: 'Вывод',
  Withdraw: 'Вывод',
  swap: 'Обмен',
  Swap: 'Обмен',
  pool: 'Пул',
  Pool: 'Пул',
  pools: 'Пулы',
  Pools: 'Пулы',
  view_pools: 'Обзор пулов',
  view_pool: 'Обзор пула',
  add_token: 'Добавить токен',
  create_new_pool: 'Создать новый пул',
  Create_New_Pool: 'Создать новый пул',
  your_liquidity: 'Ваша ликвидность',
  Your_Liquidity: 'Ваша ликвидность',
  farms: 'Фермы',
  Farms: 'Фермы',
  docs: 'Документы',
  account: 'Аккаунт',
  Discord: 'Discord',
  Telegram: 'Telegram',
  Twitter: 'Twitter',
  connect_to_near: 'Подключитесь к NEAR',
  slippage: 'Допустимое проскальзывание',
  minimum_received: 'Минимальная сумма, которую вы получите',
  swap_rate: 'Курс обмена',
  pool_fee: 'Комиссия пула',
  balance: 'Баланс',
  from: 'От',
  to: 'До',
  submit: 'Отправить',
  view_account: 'Обзор аккаунта',
  liquidity: 'Ликвидность',
  tokens: 'Токены',
  fee: 'Комиссия',
  fees: 'Комиссии',
  details: 'Подробности',
  detail: 'Подробнее',
  minimum_tokens_out: 'Минимальная сумма, которую вы получите',
  pair: 'Пара',
  tvl: 'TVL',
  add_liquidity: 'Добавить ликвидность',
  remove_liquidity: 'Удалить ликвидность',
  total_liquidity: 'Общая ликвидность',
  my_shares: 'Моя доля',
  token: 'Токен',
  enter_token_address: 'Введите адрес токена',
  remove: 'Удалить',
  select: 'Выбрать',
  select_token: 'Выбрать токен',
  total_fee: 'Итоговая комиссия % ',
  start_at: 'Запустится с',
  end_at: 'Закончится в',
  ended: 'ЗАВЕРШЕНО',
  pending: 'ОЖИДАЕТСЯ',
  rewards_per_week: 'Награды за неделю',
  apr: 'APR',
  total_staked: 'Всего застейкано',
  unclaimed_rewards: 'Невостребованные награды',
  claim: 'Запросить',
  claim_all: 'Запросить все',
  stake: 'Застейкать',
  unstake: 'Забрать из стейкинга',
  your_shares: 'Ваша доля',
  cancel: 'Отменить',
  days: 'дни',
  slippageCopyForMobile:
    'Проскальзывание означает разницу между тем, что вы ожидаете получить, и тем, что вы фактически получаете из-за других действий',
  slippageCopy:
    'Проскальзывание означает разницу между тем, что вы ожидаете получить, и тем,что вы фактически получаете из-за других действий',
  swapCopy:
    'Обмен первого выбранного токена на второй <br> выбранный токен. Будет использован пул с наибольшей доступной ликвидностью и наименьшей комиссией за обмен',
  addTokenCopy: 'Добавьте любой токен NEP-141',
  farmRewardsCopy:
    'Ориентировочная стоимость, основанная на цене, а не на фактическом исполнении',
  you_do_not_have_enough: 'У вас недостаточно',
  is_not_exist: 'отсутствует',
  must_input_a_value_greater_than_zero: 'Необходимо ввести значение больше 0',
  no_pool_available_to_make_a_swap_from: 'Нет доступного пула для обмена',
  for_the_amount: 'на сумму',
  no_pool_eng_for_chinese: ' ',
  is_not_a_valid_swap_amount: 'не соответствует сумме обмена',
  not_nep_address:
    'Введенный вами адрес не является NEP-141 адресом, пожалуйста, сверьте и введите его снова. Если это другой контракт основной сети, зайдите в Rainbow Bridge для осуществления процесса переноса',
  not_correct_address:
    'Адрес, введенный вами, неправильный, проверьте и введите правильный',
  pool_id: 'ID пула',
  more_pools: 'Больше пулов',
  my_watchlist: 'Мой список отслеживания',
  h24_volume: '24ч объем',
  volume: 'Объем',
  hide_low_tvl_pools: 'Скрыть с низким TVL',
  hide_low_tvl_pools_mobile: 'Скрыть с низким TVL',
  my_watchlist_copy: 'Отмеченные пулы будут отображаться здесь',
  language: 'Язык',
  deposit_to_add_liquidity: 'Депозит для добавления ликвидности',
  slip_warn:
    'Пожалуйста, будьте внимательны, проверьте минимальную сумму, которую вы можете получить',
  slip_invalid: 'Допустимое проскальзывание некорректно',
  reward_tokens: 'Награда в токенах',
  detail_tip: 'Подробнее',
  no_data: 'Нет данных',
  attention: 'Внимание',
  live: 'Действующие',
  ended_search: 'Завершенные',
  my_farms: 'Мои фермы',
  sort_by: 'Сортировать по',
  your_farms: 'Ваши фермы',
  new: 'Новые',
  unstake_tip_t: 'у вас есть невостребованные награды...',
  unstake_tip_m:
    'Если заберете из стейкинга, то это уберет его со всех активных и отложенных ферм этой пары.',
  unstake_tip_b: 'Вы хотите забрать из стейкинга?',
  value_rewards: 'Полученные награды',
  stake_unstake_tip:
    'Стейкинг или отмена стейкинга автоматически начислит ваши награды.',
  over_tip:
    'В связи с ограничением комиссии за газ, за один раз можно выбрать только 4 позиций',
  no_token_tip: 'Нет награды',
  getToken_tip:
    'Вы можете получить награду или застейкать свои LP токены прямо сейчас!',
  in_farm: 'в ферме',
  price_impact: 'Влияние на цену',
  roi_calculator: 'Калькулятор ROI',
  lp_staked: 'LP застейкано',
  usd: 'USD',
  lp_token: 'LP токен',
  stake_for: 'Срок',
  day_1: '1Д',
  day_2: '7Д',
  day_3: '30Д',
  day_4: '90Д',
  cur_apr: 'ROI',
  reward_token: 'Награда в токенах',
  get_lp_token: 'Получить LP доли',
  calculate_roi: 'Калькулятор ROI',
  rewards_claimed: 'Полученные награды',
  value_rewards_token: 'Стоимость наград',
  all: 'Все',
  all_5: '4 токенов за раз',
  more_than: 'Пожалуйста, введите число, которое больше или равно 0,01',
  less_than: 'Пожалуйста, введите число, которое меньше 20',
  no_valid: 'Пожалуйста, введите корректное число',
  lp_fee: 'Комиссия LP',
  referral_fee: 'Реферальная комиссия',
  protocol_fee_referral_fee: 'Плата за протокол и реферальная плата',
  total_fee_create: 'Общая комиссия',
  ref: 'REF',
  are_you_sure: 'Вы уверены',
  price_impact_is_about: 'Влияние на цену составляет около',
  yes_swap: 'Да, обменять',
  input_greater_than_available_shares: 'Введите больше чем доступно долей',
  auto_router: 'Автоматический роутер',
  optimal_path_found_by_our_solution:
    'Оптимальный путь, найденный нашим решением',
  make_sure_you_understand_what_you_do:
    'Убедитесь, что вы хорошо понимаете, что вы делаете',
  filter_by: 'Отфильтровать по',
  allOption: 'Все',
  stablecoin: 'Стейблкоин',
  near_ecosystem: 'Экосистема NEAR',
  bridged_tokens: 'Токены других сетей',
  gaming: 'Игровые проекты',
  nft: 'NFT',
  bridge: 'Перенос из/в сеть',
  no_result: 'К сожалению, мы не смогли найти ни одной подходящей фермы',
  multiple: 'Несколько',
  default: 'По умолчанию',
  create: 'Создайте',
  select_a: 'Select a',
  wallet: 'wallet',
  to_use_ref_finance: 'to use {appName}',
  not_supported: 'not supported',
  installed: 'installed',
  installe_now: 'install now',
  extension: 'extension',
  first_time_using_ref: 'First time using {appName}',
  learn_more: 'Узнать подробности',
  install_sender_now: 'Install Sender Now',
  connect_to_dapps_with_one_click: 'Connect to dApps with one click',
  install: 'install',
  Connecting: 'Connecting',
  check_sender_wallet_extension: 'Please check Sender wallet extension',
  having_trouble: 'Having trouble?',
  go_back: 'Go back',
  web: 'web',
  Type: 'Type',
  click_to_view: 'Нажмите, чтобы просмотреть',
  transaction_failed: 'Transaction failed',
  wallet_vi: ' ',
  value: 'ценность',
  usd_value: 'USD Value',
  initialize_account_tip: 'Please initialize your account.',
  support_ledger_tip:
    'По своей конструкции Ledger не может обрабатывать большие транзакции (Auto Router: торговля, что использует несколько пулов одновременно) из-за  небольшого объема памяти. Функция Support Ledger  позволит уменьшить транзакции до их простейшей  формы (в ущерб потенциально оптимальным ценам,  найденным Auto Router), в результате чего объем  tx будет небольшим, что позволит работать вам с Ledger.',
  start: 'Start',
  max: 'Макc',
  ref_account_balance_tip:
    'Похоже, произошла ошибка при добавлении/удалении ликвидности в пул',
  ref_account_tip_2: 'У вас есть токены в вашей учетной записи REF',
  ref_account_tip_top:
    'ваши токены могут сейчас находиться на вашем внутреннем счете REF',
  click_here: 'Кликните по этой ссылке',
  to_recover_them: 'чтобы восстановить их',
  ref_account_tip_3:
    'Чтобы вывести токен(ы) с вашего счета REF на ваш кошелек NEAR, пожалуйста, выберите и выведите',
  aurora_account_tip_4:
    'Чтобы вывести токен(ы) с Вашего Картографического Счета на Ваш КОШЕЛЕК NEAR, пожалуйста, выберите и выведите',
  buy: 'Купить',
  sell: 'Продать',
  rate: 'Курс',
  name: 'Имя',
  diff: 'Диф',
  best: 'Лучший',
  awesomeNear_verified_token: 'AwesomeNear верифицированный токен',
  pool_fee_apr: 'Pool fee APY',
  ref_account_balance_tip_mobile:
    'У вас есть токены в вашей учетной записи REF.',
  click: 'Нажмите',
  to_recover: 'выздороветь.',
  rewards_week: 'Rewards/week',
  rewards: 'Rewards',
  claimed_Rewards: 'Полученные награды',
  POOL: 'Пулы',
  lp_Token: 'LP Tokens',
  booster: 'Booster',
  append: 'Append',
  farm: 'Farm',
  status: 'Status',
  Rewards: 'Rewards',
  free: 'Free',
  lp_tokens: 'LP токены',
  connect_to_wallet: 'Подключить кошелек',
  slash_policy_content:
    'Each seed has its own slash rate. And it will decreases linearly over time until be 0 at the unlock time of this CD Account.',
  not_expired: 'Not expired',
  accept_pay_slash_tip: 'I accept to pay slash',
  i_will_pay: 'I will pay',
  lp_token_slash: 'LP token exit fee.',
  expired: 'Expired',
  all_4_v2: '4 токенов за раз',
  more_than_seed: 'Input must be greater than or equal to ',
  how_to_earn_more: 'Как можно заработать больше?',
  lock_your_lp_tokens_with_booster: 'Lock your LP tokens for boosted rewards',
  unstaked_anytime_no_booster: 'Unstaked anytime, no booster',
  locking_stake: 'Lock-up staking',
  change_to_lock: 'Change to Lock-up staking',
  estimated_rewards: 'Estimated rewards',
  final_booster: 'Final Booster',
  existing_amount: 'Existing amount',
  append_amount: 'Append amount',
  will_be_able_to_unstaked_after: 'will be able to unstaked after',
  you_have: 'У вас есть',
  reward_apr: 'Rewards APR',
  stake_min_deposit: 'Введеное количество должно быть больше или равно',
  unlock: 'Unlock',
  exit_fee: 'Exit fee',
  end_locking_period: 'End of locking period',
  add_lp_tokens_tip:
    'Вам нужны LP токены, чтобы застейкать их в соответствующей ферме. Для получения LP-токенов сначала добавьте ликвидность в пул.',
  slash_tip: 'Exit fee = Exit fee rate * End of locking period * Unlock amount',
  nonBoosted: 'Без буста',
  exit_fee_tip: 'Estimated amount you would pay to break your lock-up period',
  forbiddenTip: 'This farm does not support this duration option',
  unstakeTip:
    'Стейкинг или отмена стейкинга автоматически начислит ваши награды.',
  endedFarmsUnstakeTip:
    'Подобным действим вы отмените стейкинг со всех активных и предстоящих ферм данной пары',
  comimg: 'Ожидается',
  appendTip: 'Невозможно выполнить это раньше текущего времени блокировки',
  week: 'в неделю',
  yours: 'Ваши пулы',
  boost: 'Буст',
  near: 'NEAR',
  eth: 'ETH',
  others: 'Другие',
  stakeLove: 'Застейкать LOVE',
  unstakeLove: 'Забрать из стейкинга LOVE',
  get_love: 'Получить LOVE',
  swap_successful: 'Обмен прошел успешно',
  trading_successfull: 'Сделка прошла успешно',
  available_to_stake: 'доступно для стейкинга',
  your_assets: 'Ваши активы',
  connect_wallet: 'Подключить кошелек',
  disconnect: 'Отключить',
  change: 'Поменять',
  connect: 'Подключиться',
  veTip:
    'токены veLP не могут быть переданы, veLPT представляют собой ваше право голоса ',
  loveTip:
    'LOVE означает ликвидность veToken. LOVE, как и любой другой токен NEP-141, является доступным для передачи и может быть обменен, добавлен в пул или застейкан на бирже, а также задействован в фермах. LOVE представляет собой базовую ликвидность ваших veTokens.',
  keep_ve: 'сохраните',
  months: 'месяцы',
  month: 'месяц',
  lock_lp_tokens: 'Заблокируйте ваши LP токены',
  get_lptoken: 'Получите LP токены',
  duration: 'Продолжительность',
  ve_lock_tip: 'Невозможно выполнить это раньше текущего времени блокировки',
  get: 'Получить',
  you_have_no_lp_share: 'У вас нет LP токенов',
  lock: 'Заблокировать',
  locked: 'Заблокировано',
  available: 'Доступно',
  in: 'в',
  filter: 'Фильтровать',
  options: 'Опции',
  ratio: 'Рейтинг',
  back: 'Вернуться',
  confirm: 'Подтвердить',
  total: 'Итого',
  type: 'Вид',
  connect_to_near_wallet: 'Подключите NEAR кошелек',
  v1Legacy: 'Legacy',
  v2New: 'Classic-New',
  v2_new_farms: 'Classic Новые фермы',
  migrate_now: 'Выполнить миграцию!',
  v2_boost_tip:
    'Classic-фарминг будет работать для ферм с бустом. Legacy-фарминг будет лишен наград после <span class="font-bold">1 августа 2022 года</span>',
  v2_boost_no_tip:
    'Legacy-фарминг будет лишен наград после <span class="font-bold">1 августа 2022 года</span>',
  love: 'LOVE',
  Available_to_stake: 'Доступно для стейкинга',
  you_staked: 'Вы застейкали',
  has_rewards_tip_in_v2:
    'Ваши обычные награды, которые вы заберете из <a rel="noopener noreferrer nofollow" href="/farms" class="text-sm text-greenColor cursor-pointer underline ml-1 hover:text-senderHot"> Legacy Ферм</a>.',
  how_to_get: 'Как получить?',
  get_booster: 'Получите бустер',
  ended_farms: 'завершенные фермы',
  boosted_farms: 'Фермы с бустом',
  your_farm: 'Ваша ферма',
  your_boosted_farms: 'Ваши фермы с бустом',
  search_farms_by_token: 'Найти фермы по токену',
  search_farms: 'Искать фермы',
  more_lock_ve_popup2: 'больше',
  left: 'левый',
  create_pool: 'Создать пул',
  search_by_token: 'Поиск по токены',
  your_power: 'Ваша DeFi-сила',
  farm_has_boost_tip:
    'Ваша DeFi-сила = Ваши застейканные LP токены * бустер (от стейкинга LOVE)',
  farm_no_boost_tip: 'Ваша DeFi-сила = Ваши застейканные LP токены',
  more_than_a_simple_pool: 'Больше, чем обычный пул',
  ended_Farms: 'Завершенные фермы',
  vote_capital: 'Голосование',
  boostFarmTip: 'Получить буст, застейкав LOVE',
  boosted: 'Применен буст',
  love_staked: 'Застейканные LOVE',
  your_apr: 'Ваш APR',
  range_apr: 'В пределах диапазона или базового APR',
  no_pair_found: 'Пара не найдена',
  found_stable_pool_in_sauce: 'Найден стабильный пул в SAUCE',
  lp_tokens_locking: ' LP токены ',
  you_currently_have: 'В настоящее время у вас есть ',
  scheduled_to_be_unlocked: 'планируется разблокировать',
  locking_more_lp_tokens: 'Блокировка большего количества токенов LP ',
  will_mean_these: 'будет означать эти ',
  lp_tokens_will_not_be_unlocked_until:
    ' Токены LP не будут разблокированы до тех пор, пока',
  "I_understand_that_I_won't_be_able_to_remove_my":
    'Я понимаю, что не смогу удалить свой ',
  until: 'до того как',
  add: 'Добавлять',
  finish: 'Заканчивать',
  add_custom_network: 'Добавить сеть',
  network_name: 'Имя сети',
  rpc_name_taken_tip: 'Сетевое имя уже занято',
  network_invalid: 'Сеть недействительна',
  fobidden_testnet_rpc_tip:
    'Сеть сервера RPC (тестовая сеть) отличается от этой сети (основной сети)',
  no_support_testnet_rpc_tip:
    'Testnet не поддерживает добавление пользовательских RPC',
  stable: 'Stable',
  limit: 'Лимит',
  your_active_orders_will_appear_here:
    'Здесь будут отображаться ваши активные ордера',
  your_history_orders_will_appear_here:
    'Здесь будет отображаться история ваших ордеров',
  farm_only: 'Только ферма',
  please_confirm_this_transaction_on_ledger:
    'Пожалуйста, подтвердите эту транзакцию в Ledger',
  limit_order: 'Лимитный ордер',
  farm_stop_tip: 'Эта ферма приостановлена.',
  pool_stop_tip: 'Этот пул приостановлен.',
  volume_24h: 'Объем (24ч)',
  add_to_watchlist: 'Добавить в список отслеживания',
  remove_from_watchlist: 'Удалить из списка отслеживания',
  create_order: 'Создать ордер',
  filled: 'Исполнен',
  canceled: 'Отменен',
  partially_filled: 'Частично исполнен',
  pool_composition: 'Композитный пул',
  amount: 'Количество',
  h24_volume_bracket: 'Объем (24ч)',
  fee_24h: 'Комиссия (24ч)',
  orders: 'заказы',
  your_orders: 'Ваши заказы',
  active: 'Активный',
  history: 'История',
  you_sell: 'Вы продаете',
  you_buy: 'Вы покупаете',
  fee_tiers: 'Размер комиссионных',
  created: 'Создан',
  executed: 'Исполнен',
  actions: 'Активность',
  claimed_upper: 'Заявлено',
  open_my_order: 'Открыто',
  initial_order: 'Первичный ордер',
  this_order_has_been_partially_filled: 'Этот ордер был частично исполнен',
  filled_via_swap: 'Заполнен за счет обмена',
  state: 'Состояние',
  partially: 'Частично',
  near_validation_error: 'Must have 0.5N or more left in wallet for gas fee.',
  near_min_validation_error:
    'Must have 0.2N or more left in wallet for gas fee.',
  no_positons_in_this_pool_yet: 'No positons in this pool yet',
  no_claimed_rewards_yet: 'No claimed rewards yet',
  out_of: 'out of',
  fee_Tiers: 'Размер комиссионных',
  no_pool: 'Нет пула',
  input_amount: 'Введите сумму',
  update_range: 'Обновить диапазон',
  not_enough_balance: 'Недостаточный баланс',
  set_price_range: 'Установите диапазон цен',
  current_price: 'Текущая цена',
  invalid_range_tip:
    'Неверно выбран диапазон. Минимальная цена должна быть ниже максимальной.',
  maket_price_outside_single_only_tip:
    'Рыночная цена находится вне вашего ценового диапазона. Депозит только для одного актива.',
  min_price: 'Мин. цена',
  max_price: 'Макс. цена',
  min: 'Мин.',
  out_of_range: 'Вне диапазона',
  in_range: 'В диапазоне',
  unclaimed_fees: 'Невостребованные комиссии',
  your_position_will_be: 'Ваша позиция будет',
  at_this_price: 'по такой цене',
  price_range: 'Ценовой диапазон',
  positions: 'Позиции',
  position: 'Position',
  range: 'Диапазон',
  login_risk_tip:
    'By checking this box and moving forward, you confirm that you fully understand the risks of using {appName}.',
  stable_pool: 'Stable Pool',
  market_rate: 'Market Rate',
  no_token_found: 'No token found',
  search_name_or_address: 'Search name or paste address...',
  token_address_invalid: 'The token address was invalid',
  price_impact_warning: 'Price Impact Warning',
  confirm_order: 'Confirm Order',
  you_Sell: 'You Sell',
  to_Buy: 'to Buy',
  at_Price: 'at Price',
  insufficient_balance: 'Insufficient Balance',
  limitTip: 'Your price is automatically set to the closest price slot',
  v2_pools: 'DCL Pools',
  v2_your_pool_introduction: 'Your discretized concentrated liquidity',
  v1_your_pool_introduction: 'Your liquidity in classic pools',
  estimate_value: 'Estimate Value',
  price: 'Price',
  '@price': '@Price',
  trades: 'Trades',
  time: 'Time',
  balances: 'Balances',
  asset: 'Asset',
  action: 'Action',
  market: 'Market',
  Maker: 'Maker',
  chart: 'Chart',
  refresh_data_to_continue: 'Please refresh the data to continue',
  refresh: 'Refresh',
  both: 'Both',
  All: 'All',
  Filled: 'Filled',
  assets: 'Assets',
  cancel_order: 'Cancel Order',
  instrument: 'Instrument',
  dex: 'Dex',
  limit_order_created: 'Limit Order Created',
  limit_order_filled: 'Limit Order Filled',
  classic_pools: 'Classic Pools',
  active_orders: 'Active Orders',
  your_liquidity_usd_value: 'Your Liquidity (USD value)',
  usage: 'Usage',
  holding: 'Holding',
  your_lp_tokens_and_shares: 'Your LP Tokens(Shares)',
  swapped: 'Swapped',
  dcl_pool: 'DCL Pool',
  classic: 'Classic',
  classic_farms: 'Classic Farms',
  locked_in: 'locked in',
  'deposit_near_tip_0.5': 'To deposit, keep at least 0.5 NEAR to cover gas fee',
  trade: 'Trade',
  earn_2: 'Earn',
  portfolio: 'Portfolio',
  more_2: 'More',
  liquidity_pools_2: 'Liquidity Pools',
  stable_pools: 'Stable Pools',
  pool_detail: 'Pool Detail',
  new_contract_deploy_tip:
    'A new contract has been deployed! Please remove your liquidity from the old contract',
  remove_will_automatically_claim:
    'Removing will automatically claim your unclaimed fees.',
  legacy_tip: 'Found unstaked LP tokens or rewards in',
  legacy_farms: 'Legacy Farms',
  all_farms: 'All Farms',
  your_farms_2: 'Your Farms',
  dcl_farms: 'DCL Farms',
  farm_type: 'Farm type',
  farm_2: 'Farm',
  to_claim: 'To Claim',
  liquidity_staked: 'Liquidity staked',
  dcl_pool_detail: 'DCL Pool Detail',
  reward_range: 'Reward Range',
  reward_range_tip: 'Farm reward within this range',
  ending_soon: 'Ending soon',
  farm_ended_tip: 'This farm has ended.',
  farm_will_ended_tip: 'This farm will end soon.',
  new_farm: 'New Farm',
  is_coming: 'is coming',
  est_apr: 'Est. APR',
  farming: 'Farming',
  unavailable: 'Unavailable',
  hide: 'Hide',
  show: 'Show',
  your: 'Your',
  max_apr: 'Max.APR',
  you_can_earn_tip: 'Farm available, farm APR up to',
  you_can_earn_current_tip:
    'Your current staked farm ended, and new farm is coming, est. APR is',
  go_new_farm: 'Go New Farm',
  go_farm: 'Go Farm',
  in_ended_farm: 'in ended farm',
  staked: 'Staked',
  in_farm_3: 'in farm',
  estimation: 'Estimation Value',
  this_staked_tip: 'This NFT has been staked',
  dcl_liquidity: 'DCL Liquidity',
  classic_liquidity: 'Classic Liquidity',
  will_appear_here_tip: 'Your liquidity positions will appear here.',
  dcl_will_appear_here_tip: 'Your DCL liquidity positions will appear here.',
  classic_will_appear_here_tip:
    'Your Classic liquidity positions will appear here.',
  price_range_overlap_ratio: ' Price Range Overlap Ratio',
  real_time_executed_orders: 'real-time executed orders',
  real_time_executed_orders_tip:
    'When placing a sell order above market price or a buy order below market price using limit order function, {appName} will attempt to execute a swap-with-stop-point action first, and if there is any remaining amount, a limit order will be created to fill the rest.<br> Real-time executed orders refer to orders placed using the limit order function but executed through swapping. In the "History" section, you can view real-time executed orders between the earliest displayed limit order in History up to the present time.',
  swapped_history_order: 'Swapped',
  ledger_guide_tip_1:
    'To successfully use your Ledger wallet for transactions, the ',
  ledger_guide_tip_2: 'feature has been automatically activated.',
  ledger_guide_tip_3: 'Please be aware',
  ledger_guide_tip_quote: '"',
  support_ledger_tip_new: '"Support Ledger"',
  ledger_guide_tip_4:
    'that due to Ledger wallet constraints, the current rate provided by the swap function',
  ledger_guide_tip_5: 'may not be the best price.',
  ledger_guide_tip_6: '.',
  your_trade_route: 'Your Trade Route',
  markets: 'Markets',
  exchanges: 'Exchanges',
  output_est: 'Output (est.)',
  new_swap_order_tip:
    'The price is from the {appName} AMM offer and for reference only. There is no guarente that your limit order will be immediately filled. ',
  instants_swap: 'Instant Swap',
  swappped: 'Swapped',
  claimed: 'Claimed',
  executing_capital: 'Executing',
  trade_route: 'Trade Route',
  settings: 'Settings',
  no_trade_routes: 'No Trade Routes',
  steps_in_the_route: 'Steps in the Route',
  swap_chart_no_data: 'Not enough data for the chart right now.',
  last_updated: 'Last Updated',
  steps_in_the_route_zh: '',
  Burrow: 'Burrow',
  Supplied: 'Supplied',
  APY: 'APY',
  size: 'Size',
};
export default Object.assign(ru, ru_in_risks_page);
